import { store } from '../../store.js';


let isReleaseNotesInitialized = false;

export async function renderReleaseNotes() {
  if (typeof document === 'undefined') return;

  const container = document.getElementById('release-notes-container');
  if (!container) return;

  try {
    
    const supabase = (typeof window !== 'undefined') ? window.supabaseClient : null;
    if (!supabase) throw new Error("Supabase client not initialized");
    const { data, error } = await supabase

      .from('release_notes')
      .select('*')
      .order('release_date', { ascending: false });

    if (error) throw error;

    if (!data || data.length === 0) {
      container.innerHTML = `<div style="text-align: center; color: var(--text-muted); font-size: 14px; margin-top: 40px;"><p>No release notes available.</p></div>`;
      return;
    }

    container.innerHTML = ''; // Clear loading state

    data.forEach(note => {
      const dateStr = new Date(note.release_date).toLocaleDateString(undefined, {
        year: 'numeric', month: 'long', day: 'numeric'
      });

      const noteCard = document.createElement('div');
      noteCard.className = 'settings-card glass';
      noteCard.style.padding = '20px';
      noteCard.style.marginBottom = '20px';

      let contentHtml = `<div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 10px; margin-bottom: 15px;">
        <h3 style="margin: 0; font-family: 'Outfit', sans-serif; font-size: 20px;">v${note.version}</h3>
        <span style="font-size: 12px; color: var(--text-muted);">${dateStr}</span>
      </div>`;

      if (note.content) {
        if (note.content.features && note.content.features.length > 0) {
          contentHtml += `<h4 style="margin: 15px 0 8px 0; color: #4ade80; font-size: 14px;">🚀 Features</h4>`;
          contentHtml += `<ul style="margin: 0 0 15px 0; padding-left: 20px; color: var(--text-muted); font-size: 14px;">`;
          note.content.features.forEach(f => {
            contentHtml += `<li style="margin-bottom: 4px;">${f}</li>`;
          });
          contentHtml += `</ul>`;
        }

        if (note.content.bugfixes && note.content.bugfixes.length > 0) {
          contentHtml += `<h4 style="margin: 15px 0 8px 0; color: #f43f5e; font-size: 14px;">🐛 Bug Fixes</h4>`;
          contentHtml += `<ul style="margin: 0 0 15px 0; padding-left: 20px; color: var(--text-muted); font-size: 14px;">`;
          note.content.bugfixes.forEach(b => {
            contentHtml += `<li style="margin-bottom: 4px;">${b}</li>`;
          });
          contentHtml += `</ul>`;
        }
      }

      noteCard.innerHTML = contentHtml;
      container.appendChild(noteCard);
    });

  } catch (err) {
    console.error('Error fetching release notes:', err);
    container.innerHTML = `<div style="text-align: center; color: var(--text-muted); font-size: 14px; margin-top: 40px;"><p>Failed to load release notes.</p></div>`;
  }
}

export function initReleaseNotesView() {
  if (isReleaseNotesInitialized) return;
  
  if (typeof document !== 'undefined') {
    const linkBtn = document.getElementById('link-release-notes');
    if (linkBtn) {
      linkBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof window !== 'undefined' && typeof window.showView === 'function') {
          window.showView('view-release-notes');
        }
      });
    }

    const backBtn = document.getElementById('btn-back-release-notes');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (typeof window !== 'undefined' && typeof window.showView === 'function') {
          window.showView('view-settings');
        }
      });
    }
  }
  
  isReleaseNotesInitialized = true;
}
